import { createType, createActionCreator } from './helpers';
import { normalizeIds, normalizeModelList } from './Normalizer';

export function generateTypes(namespace, resource) {
  return {
    request: createType(namespace, `REQUEST_${resource}`),
    success: createType(namespace, `REQUEST_${resource}_SUCCESS`),
    failure: createType(namespace, `REQUEST_${resource}_FAILURE`),
  };
}

export function generateActions(types) {
  return {
    request: (...args) => ({ type: types.request, ...args }),
    success: createActionCreator(types.success, 'response'),
    failure: createActionCreator(types.failure, 'error'),
  };
}

export function generateReducer(key, deserializeFn, byIdKey = 'byId') {
  return {
    request: (state) => state.setIn([key, 'network', 'loading'], true),
    success: (state, action) =>
      state.withMutations((s) =>
        s
          .setIn([key, 'network', 'loading'], false)
          .setIn([key, 'network', 'error'], false)
          .setIn([key, 'ids'], normalizeIds(action.response))
          .mergeIn([byIdKey], normalizeModelList(action.response, deserializeFn)),
      ),
    failure: (state, action) =>
      state.withMutations((s) =>
        s.setIn([key, 'network', 'loading'], false).setIn([key, 'network', 'error'], action.error),
      ),
  };
}
